// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__1hOUY","file":"styles_file__5Ywkn"};